<script setup lang="ts">
import type { PropertyImage } from '~/core/entities/property';
import { useLazyLoadImage } from '~/composables/useLazyLoadImage';

interface Props {
	index: number;
	image: PropertyImage;
	variant?: 'fullFace' | 'whiteBackground' | 'transparentBackground';
}

const props = defineProps<Props>();
const imageRef =
	useTemplateRef<ComponentPublicInstance<HTMLImageElement>>('image-ref');

const IS_BIGGER_OR_EQUAL_THREE = props.index >= 3;

const imageUrl = (props.image.watermarkUrl || props.image.url)!;

const { lazilyLoadImage } = useLazyLoadImage(0.1, imageUrl);

onMounted(() => {
	if (!IS_BIGGER_OR_EQUAL_THREE) return;

	lazilyLoadImage(imageRef.value?.$el);
});
</script>

<template>
	<div class="relative flex size-full items-center justify-center">
		<NuxtImg
			ref="image-ref"
			:src="!IS_BIGGER_OR_EQUAL_THREE ? imageUrl : undefined"
			class="size-full object-cover"
			:width="variant === 'fullFace' ? 960 : 700"
			:placeholder="IS_BIGGER_OR_EQUAL_THREE && [50, 25, 75, 5]"
			:quality="variant === 'fullFace' ? 100 : 80"
			provider="AWSServerlessImageHandler"
			format="webp"
			:loading="IS_BIGGER_OR_EQUAL_THREE ? 'lazy' : 'eager'"
			:fetchpriority="IS_BIGGER_OR_EQUAL_THREE ? 'low' : 'high'"
			decoding="async"
		/>
	</div>
</template>
